var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0317 22.2858C19.0694 22.2858 22.3718 17.4488 22.3718 13.2541C22.3718 13.1167 22.3718 12.98 22.3622 12.8438C23.0047 12.3945 23.5593 11.8381 24 11.2007C23.4009 11.4574 22.7653 11.6258 22.1146 11.7002C22.7998 11.3035 23.3127 10.6795 23.5578 9.94445C22.9134 10.3142 22.2084 10.5748 21.4733 10.7149C20.9783 10.206 20.3237 9.86905 19.6108 9.75614C18.8978 9.64322 18.1663 9.76067 17.5293 10.0903C16.8923 10.4199 16.3855 10.9434 16.0872 11.5796C15.7888 12.2159 15.7157 12.9295 15.879 13.61C14.5739 13.5467 13.2971 13.2187 12.1316 12.6474C10.9661 12.076 9.93782 11.274 9.1136 10.2935C8.69382 10.9923 8.56525 11.8195 8.75407 12.6068C8.94288 13.394 9.43489 14.082 10.1299 14.5308C9.60751 14.5159 9.0965 14.3796 8.64 14.1335C8.64 14.1465 8.64 14.1601 8.64 14.1737C8.64021 14.9066 8.90257 15.6169 9.38258 16.184C9.86259 16.7511 10.5307 17.1403 11.2736 17.2854C10.7903 17.4128 10.2833 17.4315 9.79136 17.3398C10.0011 17.9706 10.4095 18.5221 10.9594 18.9174C11.5093 19.3126 12.1732 19.5318 12.8582 19.5442C11.6958 20.4276 10.2599 20.9072 8.78144 20.9057C8.52026 20.9052 8.25933 20.8899 8 20.8599C9.50121 21.7915 11.2479 22.2856 13.0317 22.2833",
    fill: "#050823"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8c2978ab7f93517e1ce9ec4906a85e35.svg";
export { ForwardRef as ReactComponent };